import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import type { Resource } from 'i18next';
import { reportMissingTranslationKey } from './missingKeyReporter';

type InitI18nOptions = {
  lng: string;
  resources: Resource;
};

const handleMissingKey = (
  lngs: readonly string[],
  ns: string,
  key: string
): void => {
  const locale = lngs[0];
  if (!locale || locale.startsWith('en')) return;
  reportMissingTranslationKey({
    locale,
    namespace: ns,
    key,
  });
};

export const initI18n = ({
  lng,
  resources,
}: InitI18nOptions): Promise<void> => {
  if (i18n.isInitialized) {
    return Promise.resolve();
  }
  return i18n
    .use(initReactI18next)
    .init({
      lng,
      fallbackLng: 'en',
      debug: false,
      resources,
      returnNull: false,
      returnEmptyString: false,
      keySeparator: false,
      interpolation: {
        escapeValue: false,
      },
      saveMissing: true,
      missingKeyHandler: handleMissingKey,
    })
    .then(() => undefined);
};
